<template>
    <div class="editable-field">
        <div class="edit-row" v-if="editing || globalEdit">
            <div class="select-wrapper">
                <select v-bind="{...$props, ...$attrs}"
                       v-model="newValue"
                       @input="$emit('update:data', $event.target.value)"
                        class="bg-blue-light rounded p-2 !border-0 text-black !w-72">
                    <slot></slot>
                </select>
            </div>
            <div style="display: inline-block" v-if="showInline">
                <font-awesome-icon style="cursor: pointer" @click="submitField" :icon="['fas', 'save']" />
                <font-awesome-icon style="cursor: pointer" @click="editing = false; newValue = value" :icon="['fas', 'window-close']" />
            </div>
        </div>
        <div class="display-row" v-if="!editing && !globalEdit">
            <span v-bind="{ ...$attrs }">{{ value }}</span>
            <font-awesome-icon v-if="showInline" style="cursor: pointer" @click="editing = true" :icon="['fas', 'edit']" />
        </div>
    </div>
</template>

<script>
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit, faWindowClose, faSave } from '@fortawesome/free-solid-svg-icons';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

    export default {
        name: "EditableSelect",
        components: {
            FontAwesomeIcon
        },
        props: {
            data: null,
            globalEdit: {
                type: Boolean,
                default: false
            },
            originalValue: String | Boolean,
            fieldType: String,
            extra: Object,
            showInline: {
                type: Boolean,
                default: true
            }
        },
        beforeCreate() {
            library.add(faEdit, faWindowClose, faSave);
        },
        data() {
            return {
                editing: false,
                newValue: this.data,
                original: this.originalValue,
                value: this.data
            }
        },
        methods: {
            submitField() {
                this.$parent.$emit('inputSubmit', this);
            }
        }
    }
</script>

<style scoped>
    .edit-row {
        display: inline-block;
        width: 100%;
    }
    .display-row {
        display: inline-block;
    }
</style>
